import type { IconSvgObject } from './types';

const ArrowUp01Icon: IconSvgObject = [
  ["path", { d: "M18 15L12 9L6 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ArrowUp01Icon;
